import { DateDefault, FilterOperator, ScoringDefinitionInterface } from '@vendasta/crm';
import { StandardIds, PlatformExtensionFieldIds } from '@galaxy/crm/static';

const Company = 'Company';
const Contact = 'Contact';

export const DefaultCompanyScoringDefinitions: ScoringDefinitionInterface[] = [
  // Google review score ≤ 4: +5 points
  {
    contribution: 5,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyGoogleReviewScore,
              operator: FilterOperator.FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO,
              values: [{ float: 4 }],
            },
          },
        ],
      },
    ],
  },
  // GBP claimed = No: +5 points
  // We have different fields tracking GBP claimed - one is from Snapshot, and one is from Lead Prospector
  {
    contribution: 5,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyGBPClaimed, // Lead prospector
              operator: FilterOperator.FILTER_OPERATOR_IS,
              values: [{ boolean: false }],
            },
          },
        ],
      },
    ],
  },
  // Google Business Profile claimed = No: +5 points
  {
    contribution: 5,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: PlatformExtensionFieldIds.GoogleBusinessProfileClaimed, // Snapshot
              operator: FilterOperator.FILTER_OPERATOR_IS,
              values: [{ boolean: false }],
            },
          },
        ],
      },
    ],
  },
  // Review grades = C: +1 points
  {
    contribution: 1,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyReviewGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS,
              values: [{ string: 'C' }],
            },
          },
        ],
      },
    ],
  },
  // Review grades = D or F: +3 points
  {
    contribution: 3,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyReviewGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS_ANY,
              values: [{ string: 'D' }, { string: 'F' }],
            },
          },
        ],
      },
    ],
  },
  // Social grades = C: +1 points
  {
    contribution: 1,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanySocialGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS,
              values: [{ string: 'C' }],
            },
          },
        ],
      },
    ],
  },
  // Social grades = D or F: +3 points
  {
    contribution: 3,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanySocialGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS_ANY,
              values: [{ string: 'D' }, { string: 'F' }],
            },
          },
        ],
      },
    ],
  },
  // Website grades = C: +1 points
  {
    contribution: 1,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyWebsiteGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS,
              values: [{ string: 'C' }],
            },
          },
        ],
      },
    ],
  },
  // Website grades = D or F: +3 points
  {
    contribution: 3,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyWebsiteGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS_ANY,
              values: [{ string: 'D' }, { string: 'F' }],
            },
          },
        ],
      },
    ],
  },
  // Listing grades = C: +1 points
  {
    contribution: 1,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyListingGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS,
              values: [{ string: 'C' }],
            },
          },
        ],
      },
    ],
  },
  // Listing grades = D or F: +3 points
  {
    contribution: 3,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyListingGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS_ANY,
              values: [{ string: 'D' }, { string: 'F' }],
            },
          },
        ],
      },
    ],
  },
  // SEO grade = C: +2 points
  {
    contribution: 2,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanySEOGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS,
              values: [{ string: 'C' }],
            },
          },
        ],
      },
    ],
  },
  // SEO grade = D or F: +3 points
  {
    contribution: 3,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanySEOGrade,
              operator: FilterOperator.FILTER_OPERATOR_IS_ANY,
              values: [{ string: 'D' }, { string: 'F' }],
            },
          },
        ],
      },
    ],
  },
  // Last campaign open date > 2 weeks: +5 points
  {
    contribution: 5,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyLastCampaignEmailOpenDate,
              operator: FilterOperator.FILTER_OPERATOR_IS_AFTER,
              values: [{ dateDefault: DateDefault.DATE_DEFAULT_LAST_WEEK }],
            },
          },
        ],
      },
    ],
  },
  // Last campaign click date > 2 weeks: +10 points
  {
    contribution: 10,
    crmObjectType: Company,
    fieldId: StandardIds.CompanyLeadScore,
    scoringRules: [
      {
        crmObjectType: Company,
        objectRules: [
          {
            filter: {
              fieldId: StandardIds.CompanyLastCampaignEmailClickedDate,
              operator: FilterOperator.FILTER_OPERATOR_IS_AFTER,
              values: [{ dateDefault: DateDefault.DATE_DEFAULT_LAST_WEEK }],
            },
          },
        ],
      },
    ],
  },
];

export function getDefaultContactScoringDefinitions(
  emailFieldId: string,
  phoneFieldId: string,
): ScoringDefinitionInterface[] {
  return [
    // Last campaign click date >= 1 week: +10 points
    {
      contribution: 10,
      crmObjectType: Contact,
      fieldId: StandardIds.ContactLeadScore,
      scoringRules: [
        {
          crmObjectType: Contact,
          objectRules: [
            {
              filter: {
                fieldId: StandardIds.ContactLastCampaignEmailClickedDate,
                operator: FilterOperator.FILTER_OPERATOR_IS_AFTER_OR_ON,
                values: [{ dateDefault: DateDefault.DATE_DEFAULT_LAST_WEEK }],
              },
            },
          ],
        },
      ],
    },
    // Last campaign open date >= 1 weeks: +5 points
    {
      contribution: 5,
      crmObjectType: Contact,
      fieldId: StandardIds.ContactLeadScore,
      scoringRules: [
        {
          crmObjectType: Contact,
          objectRules: [
            {
              filter: {
                fieldId: StandardIds.ContactLastCampaignEmailOpenDate,
                operator: FilterOperator.FILTER_OPERATOR_IS_AFTER_OR_ON,
                values: [{ dateDefault: DateDefault.DATE_DEFAULT_LAST_WEEK }],
              },
            },
          ],
        },
      ],
    },
    // No email: -5 points
    {
      contribution: -5,
      crmObjectType: Contact,
      fieldId: StandardIds.ContactLeadScore,
      scoringRules: [
        {
          crmObjectType: Contact,
          objectRules: [
            {
              filter: {
                fieldId: emailFieldId,
                operator: FilterOperator.FILTER_OPERATOR_IS_EMPTY,
              },
            },
          ],
        },
      ],
    },
    // No phone number: -5 points
    {
      contribution: -5,
      crmObjectType: Contact,
      fieldId: StandardIds.ContactLeadScore,
      scoringRules: [
        {
          crmObjectType: Contact,
          objectRules: [
            {
              filter: {
                fieldId: phoneFieldId,
                operator: FilterOperator.FILTER_OPERATOR_IS_EMPTY,
              },
            },
          ],
        },
      ],
    },
  ];
}
